import React from "react";
import Particles from "react-tsparticles";

// Definido fuera del componente para que la referencia sea estable
// y tsparticles no se reinicie (nuevas posiciones) en cada render.
const PARTICLE_PARAMS = {
  particles: {
    number: {
      value: 160,
      density: {
        enable: true,
        value_area: 1500,
      },
    },
    line_linked: {
      enable: false,
      opacity: 0.03,
    },
    move: {
      direction: "right",
      speed: 0.05,
    },
    size: {
      value: 1,
    },
    opacity: {
      anim: {
        enable: true,
        speed: 1,
        opacity_min: 0.05,
      },
    },
  },
  interactivity: {
    events: {
      onclick: {
        enable: true,
        mode: "push",
      },
    },
    modes: {
      push: {
        particles_nb: 1,
      },
    },
  },
  retina_detect: true,
};

function Particle() {
  return <Particles id="tsparticles" params={PARTICLE_PARAMS} />;
}

export default React.memo(Particle);
